/**
 * ISO week number and Australian Financial Year week utilities — frontend copy.
 * Australian FY: July 1 → June 30  (FY2026 = Jul 2025 – Jun 2026)
 */

export function getISOWeek(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt  = new Date(y, m - 1, d);
  const day = dt.getDay() || 7;
  dt.setDate(dt.getDate() + 4 - day);
  const yearStart = new Date(dt.getFullYear(), 0, 1);
  const week = Math.ceil((((dt - yearStart) / 86400000) + 1) / 7);
  return { week, year: dt.getFullYear() };
}

export function getFYWeek(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const fyYear  = m >= 7 ? y + 1 : y;
  const fyStart = new Date(fyYear - 1, 6, 1);
  const current = new Date(y, m - 1, d);
  const daysDiff = Math.floor((current - fyStart) / 86400000);
  const fyWeek   = Math.floor(daysDiff / 7) + 1;
  return { fyWeek, fyYear };
}

/** Given ISO year + week number, return the Monday date as YYYY-MM-DD. */
export function weekNumToMonday(year, weekNum) {
  const jan4   = new Date(year, 0, 4);
  const dow    = jan4.getDay() || 7;
  const w1Mon  = new Date(jan4);
  w1Mon.setDate(jan4.getDate() - dow + 1);
  const mon = new Date(w1Mon);
  mon.setDate(w1Mon.getDate() + (weekNum - 1) * 7);
  return fmt(mon);
}

/** Monday–Sunday range from any date string. */
export function getWeekRange(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt    = new Date(y, m - 1, d);
  const dow   = dt.getDay();
  const toMon = dow === 0 ? 6 : dow - 1;
  const mon   = new Date(dt); mon.setDate(dt.getDate() - toMon);
  const sun   = new Date(mon); sun.setDate(mon.getDate() + 6);
  return { from: fmt(mon), to: fmt(sun) };
}

/** Shift a YYYY-MM-DD (must be a Monday) by ±N weeks. */
export function shiftWeek(weekStart, delta) {
  const [y, m, d] = weekStart.split('-').map(Number);
  const dt = new Date(y, m - 1, d + delta * 7);
  return fmt(dt);
}

/** Return Monday of the week containing today. */
export function thisWeekStart() {
  return getWeekRange(new Date().toISOString().slice(0, 10)).from;
}

/** Format e.g. "Week 13, 2026 · FY Week 39" */
export function weekLabel(dateStr) {
  const { week, year } = getISOWeek(dateStr);
  const { fyWeek }     = getFYWeek(dateStr);
  return `Week ${week}, ${year}  ·  FY Week ${fyWeek}`;
}

/** Short range label, e.g. "Mon 23 Mar – Sun 29 Mar 2026" */
export function weekRangeLabel(fromStr, toStr) {
  const f = d => new Date(d + 'T12:00:00').toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' });
  const toYear = new Date(toStr + 'T12:00:00').getFullYear();
  return `${f(fromStr)} – ${f(toStr)} ${toYear}`;
}

function fmt(dt) {
  return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
}
